import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CheckYourEmail = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [signupCompleted, setSignupCompleted] = useState(false);

  useEffect(() => {
    const storedEmail = localStorage.getItem("signup_email");
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      setError("Signup email not found. Please go back and try again.");
    }
  }, []);

  const resendVerification = async () => {
    if (!email || loading || signupCompleted) return;

    setLoading(true);
    setMessage("");
    setError("");

    try {
      const emailActionLink =
        `${process.env.REACT_APP_FRONTEND_URL}/complete-signup?email=${encodeURIComponent(email)}`;

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/resend-verification`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            email_action_link: emailActionLink,
          }),
        }
      );

      let data = {};
      try {
        data = await response.json();
      } catch {
        data = {};
      }

      if (response.ok && data.success) {
        if (data.already_verified === true) {
          setSignupCompleted(true);
          localStorage.removeItem("signup_email");
          setMessage(
            data.message ||
              "Your email is already verified and your signup is complete. You can sign in."
          );
          return;
        }

        setMessage(
          data.message ||
            `A new verification link has been sent to ${email}. Please check your inbox.`
        );
        return;
      }

      setError(
        data.error ||
          data.message ||
          "Failed to resend the verification email. Please try again."
      );
    } catch (err) {
      console.error("❌ Resend error:", err);
      setError("Unexpected error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        {signupCompleted ? "Email verified" : "Check your email"}
      </h2>

      {!signupCompleted ? (
        <>
          <p style={styles.text}>
            We've sent a verification link to your email address.
            <br />
            Please verify your account to complete the signup process.
          </p>

          {email && (
            <p style={styles.emailInfo}>
              Sent to: <strong>{email}</strong>
            </p>
          )}

          <button
            onClick={resendVerification}
            disabled={loading || !email}
            style={{
              ...styles.button,
              ...(loading || !email ? styles.buttonDisabled : null),
            }}
          >
            {loading
              ? "Resending..."
              : "Didn’t receive the email? Click here to resend"}
          </button>
        </>
      ) : (
        <p style={styles.text}>
          Your account is ready. You can now sign in.
        </p>
      )}

      {message && <p style={styles.success}>{message}</p>}
      {error && <p style={styles.error}>{error}</p>}

      {signupCompleted && (
        <button
          onClick={() => navigate("/login")}
          style={styles.button}
        >
          Sign in
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    marginTop: "80px",
    padding: "0 20px",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#444",
    marginBottom: "10px",
  },
  emailInfo: {
    fontSize: "15px",
    color: "#555",
    marginBottom: "20px",
  },
  button: {
    padding: "12px 20px",
    fontSize: "15px",
    backgroundColor: "#1E2A78",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  buttonDisabled: {
    opacity: 0.65,
    cursor: "not-allowed",
  },
  success: {
    color: "green",
    marginTop: "15px",
  },
  error: {
    color: "red",
    marginTop: "15px",
  },
};

export default CheckYourEmail;
